import { useContext, useEffect, useRef } from 'react'
import ModalContext from 'contexts/ModalContext'
import { useAppSelector } from 'hooks/reduxHooks'
import { shouldShowSocietePrompt } from 'agentHub/selectors/agentHubSelectors'
import SocietePromptModal from 'agentHub/components/Societe/SocietePromptModal'

function useAgentHubSocieteLoginPrompt() {
  const showModal = useContext(ModalContext)
  const account = useAppSelector(state => state.agentHub.agentHubAccount.account)
  const fetching = useAppSelector(state => state.agentHub.agentHubAccount.fetching)
  const hasShown = useRef(false)

  useEffect(() => {
    if (fetching) return
    if (hasShown.current) return
    if (!shouldShowSocietePrompt(account, 'login')) return

    hasShown.current = true
    showModal(<SocietePromptModal dismissType="login" />)
  }, [showModal, account, fetching])
}

export default useAgentHubSocieteLoginPrompt
